import React from "react";

const InProgressTaskCard = ({
  totalInProgressTaskCount,
  currentMonthInProgressTaskCount,
  taskDataLoading,
}) => {
  if (taskDataLoading) {
    return (
      <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <div className="project h-100 bg-gray-200 p-3 p-lg-4 d-flex gap-3 rounded-10 shadow-sm">
          <div className="info flex-fill">
            <div
              className="glow-placeholder"
              style={{ height: "2rem", width: "50%" }}
            ></div>
            <div
              className="glow-placeholder"
              style={{ height: "1.5rem", width: "30%", marginTop: "1rem" }}
            ></div>
            <div
              className="glow-placeholder"
              style={{ height: "1rem", width: "70%", marginTop: "1rem" }}
            ></div>
          </div>
          <div
            className="icon flex-shrink-0 d-flex align-items-center justify-content-center rounded-18"
            style={{
              width: "3.75rem",
              height: "3.75rem",
              backgroundColor: "rgb(0 143 251 / 20%)",
              color: "#008FFB",
            }}
          >
            <span
              className="d-block material-symbols-outlined icon-fill"
              style={{ fontSize: "2rem" }}
            >
              play_circle
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
      <div className="task h-100 bg-gray-200 p-3 p-lg-4 d-flex gap-3 rounded-10 shadow-sm">
        <div className="info flex-fill">
          <p className="fw-semibold mb-3">Tasks In Progress</p>
          <div className="d-flex align-items-end gap-1 mb-1">
            <h2 className="fw-bold lh-1 mb-0">
              {currentMonthInProgressTaskCount}
            </h2>
            <h3 className="text-gray fw-bold lh-1 mb-1">
              /{totalInProgressTaskCount} Tasks
            </h3>
          </div>
        </div>
        <div
          className="icon flex-shrink-0 d-flex align-items-center justify-content-center rounded-18"
          style={{
            width: "3.75rem",
            height: "3.75rem",
            backgroundColor: "rgb(153 102 255 / 20%)",
            color: "#9966FF",
          }}
        >
          <span
            className="d-block material-symbols-outlined icon-fill"
            style={{ fontSize: "2rem" }}
          >
            play_circle
          </span>
        </div>
      </div>
    </div>
  );
};

export default InProgressTaskCard;
